/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class TaskAssignmentGroups {
    static readonly userSupport: string = "0b351afc-d868-4a83-a002-26e1b3474459";
    static readonly carrierServices: string = "caef3b00-34f2-4b62-85d1-7031e6aead4b";
    static readonly transloaderServices: string = "edc3ba9b-fa95-491f-a379-780050cace46";
    static readonly contractsAndInsurance: string = "a86a7675-52ab-401e-b8a2-aaca50c7ffdc";
    static readonly compliance: string = "f3f32c76-e6cc-45f7-ac36-bfa499e93926";
}
